var lexer = {};

export { lexer as __exports };
//# sourceMappingURL=lexer.mjs.map
